/*
 * Bisou Rivage — « Associez-le » (version ALT, v7 du 21/10/2026 : le pack)
 * Sous le premier écran de la fiche produit : un mur montre le tirage choisi et un ou deux compagnons,
 * dans le même format et la même finition. Règle du 16/10 (Max) : toujours le même sens (un carré va
 * avec les deux, un sens inconnu n'est pas proposé), aucun tirage déjà au panier, aucun hasard.
 * 20/10 (Max) : les compagnons sont calculés — coups de cœur, vus récemment, duos de l'équipe, ambiance
 * et sujets, couleurs — et une phrase courte dit pourquoi.
 * 21/10 (Max, v5-6 : « il faut qu'on comprenne qu'on puisse faire un pack », « comme à la Bambu Lab ») :
 * plus de flèches ; on arrive dans un pack de deux, la remise du palier atteint s'allume (2 tirages, 3 tirages),
 * le prix du pack avant et après ; « Changer » remplace un compagnon par la suggestion suivante du classement,
 * « + » ajoute un troisième tirage ; « Voir côte à côte » ouvre la page avec ces tirages ; un bouton ajoute tout
 * au panier. Aucun compagnon valable : le bloc ne s'affiche pas. Sa place est gardée pendant le calcul.
 * 22/10 (Max, v6-11 : « associez le marche toujours pas hyper bien ») : le pack s'annonce dans le premier écran
 * (une ligne sous la réassurance, à partir de 750 px) ; les paliers passent en haut du bloc, à côté du titre ;
 * plus de place en pointillés (le « + −15 % ») : le palier « 3 tirages » ajoute le troisième, les tirages du
 * mur grandissent ; un seul bouton principal, « Voir côte à côte » devient un lien ; la mention d'aperçu se
 * réduit à un petit « aperçu ».
 * N'utilise que l'API panier publique de Shopify et le tiroir panier du thème.
 */
(function () {
  'use strict';

  /* Le nom de « Composer mon mur » va changer (question posée à Max le 20/10) : le seul endroit à remplacer */
  var NOM_MUR = 'Côte à côte';

  /* ---------- Les accords : le compagnon est calculé, jamais tiré au hasard ----------
     Max, 20/10 : « par rapport à la personne, ce qu'il aime, et aussi à l'image elle-même, par rapport
     au thème, par rapport aux couleurs ». Chaque candidat gagne des points ; la raison qui pèse le plus
     s'affiche. Exposé dans window.BisouAccords pour que « Composer mon mur » s'en serve :
     BisouAccords.classer(principal, candidats, signaux) — principal et candidats sont des produits
     Shopify (/products/<handle>.js, avec leurs balises), signaux = { wish, recent, team } (des handles)
     et gouts (les produits en coups de cœur). Rend [{ handle, score, raison, texte }], du meilleur au moins bon.
     Le sens et le panier se filtrent avant : classer ne fait que l'ordre. */
  var RAISONS = {
    wish: 'Dans vos coups de cœur',
    team: 'Choisi par l’équipe',
    ambiance: 'Même ambiance',
    couleurs: 'Couleurs qui s’accordent',
    recent: 'Vu récemment',
    gouts: 'Proche de vos coups de cœur',
    base: 'Même format, même finition'
  };
  /* À égalité de points, la raison la plus parlante l'emporte */
  var ORDRE = ['wish', 'team', 'ambiance', 'couleurs', 'recent', 'gouts'];
  function tagsOf(p) {
    var t = (p && p.tags) || [];
    if (typeof t === 'string') t = t.split(',');
    return t.map(function (x) { return String(x).trim().toLowerCase(); });
  }
  function family(tags, prefix) { return tags.filter(function (t) { return t.indexOf(prefix) === 0; }); }
  function shared(a, b) { var n = 0; a.forEach(function (t) { if (b.indexOf(t) > -1) n++; }); return n; }
  function classer(principal, candidats, sig) {
    sig = sig || {};
    var wish = sig.wish || [], recent = sig.recent || [], team = sig.team || [];
    var tp = tagsOf(principal), ph = principal && principal.handle;
    var pAmb = family(tp, 'ambiance-'), pSuj = family(tp, 'sujet-'), pCol = family(tp, 'couleur-');
    /* Les goûts : ambiances et sujets des coups de cœur seulement (un tirage vu n'est pas aimé :
       « Proche de vos coups de cœur » doit rester vrai) */
    var gouts = (sig.gouts || []).filter(function (p) { return p && wish.indexOf(p.handle) > -1; }).map(function (p) {
      return { h: p && p.handle, t: tagsOf(p).filter(function (x) { return /^(ambiance|sujet)-/.test(x); }) };
    });
    return (candidats || []).map(function (p, i) {
      var h = p && p.handle, tc = tagsOf(p), pts = {};
      if (wish.indexOf(h) > -1) pts.wish = 50;
      if (team.indexOf(h) > -1) pts.team = 45;
      var amb = shared(family(tc, 'ambiance-'), pAmb) * 8 + shared(family(tc, 'sujet-'), pSuj) * 5;
      if (amb) pts.ambiance = Math.min(30, amb);
      var col = shared(family(tc, 'couleur-'), pCol) * 8;
      if (col) pts.couleurs = Math.min(24, col);
      if (recent.indexOf(h) > -1) pts.recent = 12;
      var g = 0;
      gouts.forEach(function (x) { if (x.h !== h && x.h !== ph) g += shared(x.t, tc); });
      if (g) pts.gouts = Math.min(12, g * 2);
      var score = 0, best = 'base';
      ORDRE.forEach(function (k) {
        if (!pts[k]) return;
        score += pts[k];
        if (best === 'base' || pts[k] > pts[best]) best = k;
      });
      return { handle: h, score: score, raison: best, texte: RAISONS[best], rang: i };
    }).sort(function (a, b) { return (b.score - a.score) || (a.rang - b.rang); });
  }

  /* Coups de cœur du visiteur (wishlist du thème, sans compte) */
  function wishHandles() {
    var items = [];
    try {
      if (window.BisouWishlist && typeof window.BisouWishlist.read === 'function') items = window.BisouWishlist.read();
      else {
        var d = JSON.parse(localStorage.getItem('br_wishlist_v1'));
        items = d && Array.isArray(d.items) ? d.items : [];
      }
    } catch (e) { items = []; }
    /* Les plus récents d'abord */
    return items.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); })
      .map(function (i) { return i && i.h; }).filter(Boolean);
  }
  /* Tirages vus récemment (section « Vus récemment », clé bisou-vus), les plus récents d'abord */
  function recentHandles() {
    var a = [];
    try { a = JSON.parse(localStorage.getItem('bisou-vus') || '[]'); } catch (e) { a = []; }
    return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && h; }) : [];
  }

  window.BisouAccords = { raisons: RAISONS, classer: classer, coeurs: wishHandles, vus: recentHandles };

  var cfgEl = document.getElementById('bvf-duo-config');
  /* bvf-duo-off : pas de bloc « Associez-le », la place gardée sous la fiche se libère (assets/bisou-variant-ui.css) */
  if (!cfgEl) { document.documentElement.classList.add('bvf-duo-off'); return; }
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { document.documentElement.classList.add('bvf-duo-off'); return; }
  var L = CFG.labels || {};
  /* 26/10 au soir (a26-fiche-associez-le) : les trois libellés neufs ne passent pas par les locales (tenues par une autre fiche) ;
     27/10 (langues-continue-fiche-tirage-2) : une table par langue de la page, l'anglais pour une langue sans table */
  var L26S = {
    fr: { other: 'Proposer un autre', back: 'Revenir au précédent', tryo: 'Ajouter d’autres tirages', wall: 'Composer mon mur', lineN: '[n] tirages', more: 'Encore [k] pour −[p] %', cumul: '−[p] % dès [n] tirages', cumulN: '−[p] % dès [n]' },
    en: { other: 'Suggest another', back: 'Back to the previous one', tryo: 'Add more prints', wall: 'Plan my wall', lineN: '[n] prints', more: '[k] more for −[p]%', cumul: '−[p]% from [n] prints', cumulN: '−[p]% from [n]' },
    es: { other: 'Otra sugerencia', back: 'Volver a la anterior', tryo: 'Añadir otras láminas', wall: 'Componer mi pared', lineN: '[n] láminas', more: '[k] más para −[p] %', cumul: '−[p] % desde [n] láminas', cumulN: '−[p] % desde [n]' },
    ja: { other: '別のおすすめを見る', back: '前のプリントに戻る', tryo: 'ほかのプリントを追加', wall: '自分の壁をつくる', lineN: '[n]点', more: 'あと[k]点で−[p]%', cumul: '[n]点から−[p]%', cumulN: '[n]点から−[p]%' }
  };
  var L26 = L26S[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || L26S.en;
  var root = document.documentElement;
  var SHOW = 12;    /* compagnons essayés au plus (le choix du sélecteur) */
  var MAXN = 5;     /* 23/10 (Max) : un lot de 2 à 5 tirages */
  var cache = {};

  /* Artistes : la table du catalogue posée par la section (panier compagnon) ; elle donne aussi, dès le
     chargement, le sens de votre tirage (la place gardée prend la hauteur du mur à venir) */
  var ARTISTS = {}, MAIN_O = '';
  var RATIO = { v: 0.71, h: 1.41, c: 1 };   /* largeur / hauteur d'un tirage de chaque sens */
  try {
    var catEl = document.getElementById('bvf-catalog');
    if (catEl) JSON.parse(catEl.textContent).forEach(function (p) {
      if (p.n) ARTISTS[p.h] = p.n;
      if (p.h === CFG.handle) MAIN_O = tagOrient({ tags: [p.o || ''] });
    });
  } catch (e) { /* sans artistes */ }

  /* Remise duo / trio : affichée seulement si elle existe dans Shopify (case cochée),
     ou dans l'aperçu d'un thème non publié pour juger du rendu. */
  var OFFER = CFG.offer || {};
  var theme = window.Shopify && window.Shopify.theme;
  var isPreview = !!(theme && theme.role && theme.role !== 'main');
  var offerOn = !!(OFFER.live || isPreview);
  /* 23/10 : les paliers de 2 à 5 tirages (p2…p5 de la configuration) ; un palier non réglé garde la remise du
     précédent. Aujourd'hui seuls p2 et p3 existent : 4 et 5 tirages gardent −15 %, sans palier affiché. */
  function pctFor(n) {
    if (!offerOn) return 0;
    var best = 0;
    for (var k = 2; k <= Math.min(n, MAXN); k++) { var p = Number(OFFER['p' + k]) || 0; if (p) best = p; }
    return best;
  }
  function tierList() {
    var out = [];
    for (var k = 2; k <= MAXN; k++) if (offerOn && Number(OFFER['p' + k])) out.push(k);
    return out;
  }
  /* La mention sous le prix du pack : celle de la remise créée, ou, dans l'aperçu, la mention d'aperçu
     (21/10, règle commune du dossier v5 : Max juge les paliers sur l'ALT, aucune remise n'existe encore) */
  var NOTE = OFFER.live ? (OFFER.note || '') : '';
  /* 22/10 (v6-11) : dans l'aperçu, la mention se réduit à un petit « aperçu » près du prix ; la phrase entière en infobulle */
  var PREVIEW_NOTE = !OFFER.live && isPreview ? (OFFER.preview || 'Aperçu') : '';

  function isOff() { return root.classList.contains('bvf-off'); }
  /* 27/10 (b27-fiche-associez-le ; mesuré par b27-fiche-cadrage-defilement : le plus gros poste de script au défilement) :
     l'en-tête réécrit les classes de <html> à chaque image, le plus souvent à l'identique. On ne réagit qu'à un vrai
     changement : l'état d'avant le lot (oldValue du premier relevé) diffère de l'état d'après. */
  function rootClassMoved(list) {
    var before = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].target !== root) return true;
      if (before === null) before = list[i].oldValue;
    }
    return before !== root.className;
  }
  function money(cents) {
    /* 28/10 (c28b-prix-devise-fiche) : hors euro (région Japon, Royaume-Uni…), la devise active, écrite comme
       les cartes « À partir de » de la boutique (« ¥17,100 », « £82.00 ») ; les prix reçus sont déjà convertis. */
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    if (cur !== 'EUR') {
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format((cents || 0) / 100); } catch (e) { /* repli */ }
    }
    var whole = Math.floor((cents || 0) / 100), rest = (cents || 0) % 100;
    var t = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (rest) t += ',' + (rest < 10 ? '0' : '') + rest;
    return t + ' €';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function tpl(s, n) { return String(s || '').replace('[n]', n); }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function headerH() {
    var h = document.querySelector('.section-header') || document.querySelector('sticky-header');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }
  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    cache[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('produit ' + handle); return r.json(); });
    return cache[handle];
  }
  function sameOptions(a, b) {
    var oa = a.options || [], ob = b.options || [];
    if (oa.length !== ob.length) return false;
    for (var i = 0; i < oa.length; i++) if (String(oa[i]).toLowerCase() !== String(ob[i]).toLowerCase()) return false;
    return true;
  }
  /* Image du tirage : celle de la variante (format + finition), sinon la première du produit */
  function imgInfo(product, variant) {
    var fi = variant && variant.featured_image;
    if (fi && fi.src) return { src: fi.src, w: fi.width || 0, h: fi.height || 0 };
    var m = (product.media || []).filter(function (x) { return x.media_type === 'image' && x.src; })[0];
    if (m) return { src: m.src, w: m.width || 0, h: m.height || 0 };
    return { src: product.featured_image || '', w: 0, h: 0 };
  }

  /* Les visuels sont des PNG transparents où le tirage n'occupe qu'une partie du fond.
     On mesure la zone réellement dessinée sur une vignette, puis on demande au CDN Shopify
     de recadrer l'image sur cette zone : tous les tirages s'affichent à la même hauteur. */
  var boxes = {};
  function measure(src) {
    if (!src) return Promise.resolve(null);
    if (boxes[src]) return boxes[src];
    boxes[src] = new Promise(function (resolve) {
      var im = new Image(), done = false;
      var timer = setTimeout(function () { finish(null); }, 4000);
      function finish(v) { if (done) return; done = true; clearTimeout(timer); resolve(v); }
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, w, h).data;
          var x0 = w, y0 = h, x1 = -1, y1 = -1, opaque = 0;
          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              var a = d[(y * w + x) * 4 + 3];
              if (a > 250) opaque++;
              if (a > 24) {
                if (x < x0) x0 = x; if (x > x1) x1 = x;
                if (y < y0) y0 = y; if (y > y1) y1 = y;
              }
            }
          }
          if (x1 < 0) return finish(null);
          /* Visuel sans transparence (fond blanc) : on cherche la zone qui n'est pas blanche */
          if (opaque > w * h * 0.95) {
            var u0 = w, v0 = h, u1 = -1, v1 = -1;
            for (var yy = 0; yy < h; yy++) {
              for (var xx = 0; xx < w; xx++) {
                var i = (yy * w + xx) * 4;
                if (d[i] < 236 || d[i + 1] < 236 || d[i + 2] < 236) {
                  if (xx < u0) u0 = xx; if (xx > u1) u1 = xx;
                  if (yy < v0) v0 = yy; if (yy > v1) v1 = yy;
                }
              }
            }
            if (u1 >= 0 && (u1 - u0 + 1) * (v1 - v0 + 1) > w * h * 0.2) {
              var mx = Math.round(w * 0.025), my = Math.round(h * 0.025);
              x0 = Math.max(0, u0 - mx); x1 = Math.min(w - 1, u1 + mx);
              y0 = Math.max(0, v0 - my); y1 = Math.min(h - 1, v1 + my);
            }
          }
          finish({ l: x0 / w, t: y0 / h, r: (x1 + 1) / w, b: (y1 + 1) / h });
        } catch (e) { finish(null); }
      };
      im.onerror = function () { finish(null); };
      im.src = sized(src, 120);
    });
    return boxes[src];
  }
  function cropped(info, box, height) {
    var src = info.src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    /* known : le ratio vient de l'image ; sinon 0.8 n'est qu'un repli d'affichage, pas un sens */
    if (!box || !info.w || !info.h) return { url: src + sep + 'height=' + height, ratio: info.w && info.h ? info.w / info.h : 0.8, known: !!(info.w && info.h), plain: src };
    var m = 0.004;
    var l = Math.max(0, box.l - m), t = Math.max(0, box.t - m), r = Math.min(1, box.r + m), b = Math.min(1, box.b + m);
    var X = Math.round(l * info.w), Y = Math.round(t * info.h);
    var W = Math.max(1, Math.round((r - l) * info.w)), H = Math.max(1, Math.round((b - t) * info.h));
    return {
      url: src + sep + 'crop=region&crop_left=' + X + '&crop_top=' + Y + '&crop_width=' + W + '&crop_height=' + H + '&height=' + height,
      ratio: W / H,
      known: true,
      plain: src
    };
  }

  /* Duos choisis par l'équipe : CFG.teamDuos = [[handleA, handleB], …]. Aucune source de données
     aujourd'hui : la liste est vide, sa place dans l'ordre est gardée. */
  function teamHandles() {
    var out = [];
    (CFG.teamDuos || []).forEach(function (d) {
      var i = Array.isArray(d) ? d.indexOf(CFG.handle) : -1;
      if (i > -1) d.forEach(function (h, j) { if (j !== i && typeof h === 'string') out.push(h); });
    });
    return out;
  }
  /* Le pack montré reste le même pendant la visite (24/10) : changer de format, revenir sur la fiche ou
     voir arriver les associations (#rv5-bloc-associated se remplit après coup) ne le remplace plus.
     Une nouvelle visite repart du classement. */
  var MEMO = 'bvf-duo-pack';
  function packMemo() {
    try {
      var m = JSON.parse(sessionStorage.getItem(MEMO) || '{}'), a = m && m[CFG.handle];
      return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function rememberPack(hs) {
    try {
      var m = JSON.parse(sessionStorage.getItem(MEMO) || '{}') || {};
      m[CFG.handle] = hs;
      sessionStorage.setItem(MEMO, JSON.stringify(m));
    } catch (e) { /* stockage indisponible */ }
  }
  /* Le vivier des compagnons (16/10) : le pack retenu, coups de cœur, vus récemment, duos de l'équipe,
     puis les associations du thème et la liste serveur ; classer() en fait l'ordre (20/10).
     skip : les tirages à écarter (ceux du panier). */
  function companionHandles(skip) {
    var seen = {}, out = [];
    skip = skip || {};
    seen[CFG.handle] = true;
    function take(list, src, max) {
      var n = 0;
      list.forEach(function (h) {
        if (n >= max || !h || seen[h] || skip[h]) return;
        seen[h] = true; n++;
        out.push({ h: h, src: src });
      });
    }
    take(packMemo(), 'memo', MAXN);
    take(wishHandles(), 'wish', 8);
    take(recentHandles(), 'recent', 8);
    take(teamHandles(), 'team', 8);
    var rest = [];
    var assoc = document.getElementById('rv5-bloc-associated');
    if (assoc) {
      assoc.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) rest.push(m[1]);
      });
    }
    take(rest.concat(CFG.companions || []), 'rest', 14);
    return out;
  }
  /* Le sens porté par les balises, comme snippets/br-orientation : h, v, c (carré) ou '' */
  function tagOrient(p) {
    var tags = (p && p.tags) || [], o = '';
    if (typeof tags === 'string') tags = tags.split(',');
    tags.forEach(function (t) {
      t = String(t).trim().toLowerCase();
      if (o || t.indexOf('orientation') !== 0) return;
      if (/horizontal|paysage/.test(t)) o = 'h';
      else if (/vertical|portrait/.test(t)) o = 'v';
      else if (/carr|square/.test(t)) o = 'c';
    });
    return o;
  }
  /* Même sens, ou un carré (il va avec les deux). Un sens inconnu ne va avec rien. */
  function sameSense(a, b) { return !!a && !!b && (a === b || a === 'c' || b === 'c'); }
  /* Les tirages déjà au panier (handle → true), relus quand le panier change */
  var cartP = null;
  function readCart() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    cartP = fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('panier'); return r.json(); })
      .then(function (c) {
        var s = {};
        ((c && c.items) || []).forEach(function (i) { if (i && i.handle) s[i.handle] = true; });
        return s;
      })
      .catch(function () { return {}; });
    return cartP;
  }
  function currentVariantId() {
    var input = document.querySelector('product-form input[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? Number(input.value) : null;
  }

  var NEXT = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var BACK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M13 8H3M7 4L3 8l4 4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" fill="currentColor"/></svg>';
  var SWAP = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 5.5h10M10 3l2.5 2.5L10 8M13.5 10.5h-10M6 8l-2.5 2.5L6 13" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* 27/10 (b27-fiche-associez-le, Max : « une autre avec les flèches là, c'est moche ») : deux cadres qui se relaient */
  var ANOTHER = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="6.5" width="9" height="11" rx="1" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M7.5 3.5h9a1 1 0 0 1 1 1v10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M15.5 12.5l2 2 2-2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CLOSE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var CHECK = '<svg class="bvf-assoc__tierok" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- Le bloc ---------- */
  function build() {
    var box = el('section', 'bvf-assoc');
    box.id = 'bvf-assoc';
    box.setAttribute('data-bvf', 'assoc');
    box.setAttribute('aria-labelledby', 'bvf-assoc-title');
    box.hidden = true;

    var head = el('div', 'bvf-assoc__head');
    var h = el('h2', 'bvf-assoc__title', L.title || 'Associez-le');
    h.id = 'bvf-assoc-title';
    head.appendChild(h);
    /* Les paliers, à côté du titre (22/10, v6-11 : l'offre se lit d'abord) ; celui atteint en couleur, un clic change
       la taille du pack (« 3 tirages » ajoute le troisième) */
    var tiers = el('div', 'bvf-assoc__tiers');
    tiers.setAttribute('role', 'group');
    tiers.setAttribute('aria-label', L.tiers || 'Remise du pack');
    head.appendChild(tiers);
    /* 26/10 (Max : « en haut à droite […] un bouton […] pour aller configurer ou tester avec d'autres ») : Côte à côte,
       avec les tirages du lot déjà posés */
    var tryo = el('a', 'bvf-assoc__try');
    tryo.innerHTML = '<span>' + L26.tryo + '</span>' + NEXT;
    tryo.href = L.plannerUrl || '/pages/framed-wall-planner';
    box.appendChild(head);
    /* Plus de paragraphe d'introduction (20/10, Max : « du texte qu'on va jamais lire ») */

    /* Le mur : votre tirage et ses compagnons, à la même hauteur ; plus de flèches sur les côtés (21/10, v5-6) */
    var stage = el('div', 'bvf-assoc__stage');
    var wall = el('div', 'bvf-assoc__wall');
    stage.appendChild(wall);
    /* 23/10 (Max : « un bouton pour ajouter un tirage […] et on peut choisir direct ») : jusqu'à 5 tirages,
       choisis dans le sélecteur, sans passer par Côte à côte */
    var plus = el('button', 'bvf-assoc__plus');
    plus.type = 'button';
    plus.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 3v10M3 8h10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg><span>' + (L.addOne || 'Ajouter un tirage') + '</span>';
    stage.appendChild(plus);
    /* Le titre et l'artiste du tirage proposé, deux à trois secondes (26/10) */
    var flash = el('div', 'bvf-assoc__flash');
    flash.setAttribute('aria-live', 'polite');
    stage.appendChild(flash);
    /* 28/10 (c28-fiche-associez-le, Max : « ajouter d'autres tirages […] passe inaperçu d'être en haut à droite ») :
       sous le duo, là où l'œil passe ; la flèche du retour en haut à gauche du mur, pour que la rangée des boutons
       garde les colonnes du haut de la fiche. 30/10 (c30b-associez-le-retouches, Max : « ajouter d'autres tirages, on peut
       le mettre en bas à droite, mais avec pas un bouton gros comme ça ») : un lien discret sous les boutons, à droite */
    box.appendChild(stage);

    /* Le prix du pack, sous le mur (21/10, « comme à la Bambu Lab ») : avant et après la remise */
    var pack = el('div', 'bvf-assoc__pack');
    var total = el('p', 'bvf-assoc__total');
    total.setAttribute('aria-live', 'polite');
    pack.appendChild(total);
    /* 27/10 (Max : « le −10 %, on comprend pas qu'on peut en avoir plus ») : les paliers réels, à la suite, sous le prix */
    var cumul = el('p', 'bvf-assoc__cumul');
    cumul.hidden = true;
    pack.appendChild(cumul);
    /* 29/10 (c29m-fiche-boutons-tel, Max au téléphone : « les petits pourcentages […] les uns sur les autres ») : au
       téléphone, le seul palier suivant, en petit, sous le prix (la rangée des paliers y est cachée, bisou-duo.css) */
    var next = el('p', 'bvf-assoc__next');
    next.hidden = true;
    pack.appendChild(next);
    /* 29/10 (c29u-associez-le-ligne, Max au téléphone : « le −10 %, −15 %, −30 %, c'est un peu le bordel. Faudrait juste
       une ligne simple, comme on a dans la wishlist ») : au téléphone, une seule ligne résume le lot, comme la barre des
       Favoris (« 2 tirages · −10 % · Encore 1 pour −15 % ») et le prix payé à droite ; la rangée du prix et le palier du
       dessous y sont cachés (bisou-duo.css) */
    var line = el('p', 'bvf-assoc__line');
    pack.appendChild(line);
    box.appendChild(pack);
    /* La mention de la remise est connue d'avance : posée tout de suite, elle ne fait rien sauter */
    var note = el('p', 'bvf-assoc__note');
    note.textContent = pctFor(2) ? NOTE : '';
    note.hidden = !note.textContent;
    box.appendChild(note);

    /* Un seul bouton principal, tout ajouter au panier (22/10, v6-11) ; 23/10 (Max : « comme dans le bloc du haut,
       un bouton de 3/4 et à droite le bouton simuler sur un mur ») : le mur passe à droite, en bouton */
    var actions = el('div', 'bvf-assoc__actions');
    /* 26/10 (Max : « la même config que Ajouter et En savoir plus plus haut, sauf inversée ») : « Proposer un autre »
       à gauche, la flèche qui revient au précédent, « Ajouter au panier » à droite */
    var alt = el('div', 'bvf-assoc__alt');
    var back = el('button', 'bvf-assoc__back');
    back.type = 'button';
    back.innerHTML = BACK;
    back.setAttribute('aria-label', L26.back);
    back.title = L26.back;
    back.disabled = true;
    back.classList.add('is-gone');
    stage.appendChild(back);
    var other = el('button', 'bvf-assoc__other');
    other.type = 'button';
    other.innerHTML = ANOTHER;
    other.appendChild(el('span', null, L26.other));
    alt.appendChild(other);
    actions.appendChild(alt);
    var add = el('button', 'bvf-assoc__add');
    add.type = 'button';
    actions.appendChild(add);
    var compose = el('a', 'bvf-assoc__compose');
    /* 29/10 (c29m-fiche-boutons-tel, Max : « à droite genre bosser côte à côte […] un terme qui puisse exprimer l'idée ») :
       caché à l'ordinateur, il revient au téléphone à droite de « Proposer un autre » et ouvre Côte à côte avec le lot ;
       son nom lu est son texte */
    compose.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="4.5" width="6" height="8" fill="none" stroke="currentColor" stroke-width="1.3"/><rect x="11.5" y="4.5" width="6" height="8" fill="none" stroke="currentColor" stroke-width="1.3"/><path d="M1.5 16.5h17" stroke="currentColor" stroke-width="1.3"/></svg><span>' + (L26.wall || L.wall || 'Sur un mur') + '</span>';
    compose.href = L.plannerUrl || '/pages/framed-wall-planner';
    actions.appendChild(compose);
    box.appendChild(actions);
    box.appendChild(tryo);
    var msg = el('p', 'bvf-assoc__msg');
    msg.hidden = true;
    msg.setAttribute('role', 'alert');
    box.appendChild(msg);

    /* L'annonce du pack dans le premier écran (22/10, v6-11 : le bloc est sous la ligne de flottaison) : les tirages
       du pack en petit, le prix avant et après ; un clic descend au bloc. Remplie par render(). */
    var teaser = el('a', 'bvf-assoc-teaser');
    teaser.href = '#bvf-assoc';
    teaser.setAttribute('data-bvf', 'assoc-teaser');
    teaser.hidden = true;
    return { box: box, stage: stage, wall: wall, tiers: tiers, total: total, compose: compose, add: add, note: note, msg: msg, teaser: teaser, title: h, plus: plus, tryo: tryo, flash: flash, back: back, other: other, cumul: cumul, next: next, line: line };
  }

  function init() {
    if (!companionHandles().length) { root.classList.add('bvf-duo-off'); return; }
    readCart();
    var old = document.getElementById('rv5-bloc-associated');
    var s1 = document.querySelector('.bisou-s1-wrapper');
    var container = (old && old.parentNode) || (s1 && s1.parentNode);
    if (!container) { root.classList.add('bvf-duo-off'); return; }

    /* 21/10 (Max, v4-1 : le bloc confiance « fait un chapeau » à Associez-le) : il ne quitte plus le premier
       écran, il reste sous le bouton d'achat (la réassurance, assets/bisou-ventes-fidelite.css). Ce bloc prend
       sa place d'avant, juste sous le premier écran. */
    function trustAnchor() {
      return document.querySelector('[data-bvf="trust"]') && s1 && s1.parentNode ? s1 : null;
    }
    /* 20/10, Max : trop d'espace entre le bouton d'achat et le bloc confiance. Le premier écran reste
       centré dans la fenêtre ; le bloc confiance remonte dans le vide laissé sous son contenu.
       Seulement quand ce premier écran est centré (900 px et plus) et « En savoir plus » fermé : ouvert,
       le module occupe ce vide (dans le flux sous 900 px, sur tout le premier écran au-delà). */
    var wideMq = window.matchMedia('(min-width: 900px)');
    function pullTrust() {
      var t = document.querySelector('[data-bvf="trust"]');
      var inner = s1 && s1.querySelector('.bisou-s1-sticky');
      if (!t) return;
      var open = s1 && (s1.classList.contains('bmk-on') || root.classList.contains('bmk-open'));
      if (!inner || !wideMq.matches || open || t.previousElementSibling !== s1 || window.getComputedStyle(inner).position === 'sticky') {
        t.style.removeProperty('--bvf-trust-pull');
        return;
      }
      /* 20/10 au soir, Max : remonté à 32 px, il entrait dans la composition du premier écran. Il se range
         maintenant juste sous ce premier écran (24 px sous le bas de la fenêtre, page en haut), à 48 px au
         moins du contenu : plus d'air qu'à 32 px, moins qu'à l'origine (bas du premier écran + 12 px). */
      var y = window.pageYOffset || 0;
      var want = Math.max(inner.getBoundingClientRect().bottom + y + 48, window.innerHeight + 24);
      t.style.setProperty('--bvf-trust-pull', Math.round(s1.getBoundingClientRect().bottom + y + 12 - want) + 'px');
    }
    var ui = build();
    var trustEl = trustAnchor();
    if (trustEl) container.insertBefore(ui.box, trustEl.nextSibling);
    else if (old) container.insertBefore(ui.box, old); else container.insertBefore(ui.box, s1.nextSibling);
    /* L'annonce du pack, au bas du premier écran : sous la réassurance si elle y est, sinon sous le bouton d'achat */
    function teaserAnchor() {
      var st = s1 && s1.querySelector('.bisou-s1-sticky');
      if (!st) return null;
      return st.querySelector(':scope > .bvf-trust') || st.querySelector(':scope > .bisou-buy-row');
    }
    function placeTeaser() {
      var a = teaserAnchor();
      if (!a) return;
      if (ui.teaser.previousElementSibling !== a) a.parentNode.insertBefore(ui.teaser, a.nextSibling);
      /* La colonne range ses blocs par « order » (flex) : l'annonce prend le rang de son voisin, et le suit */
      var o = window.getComputedStyle(a).order;
      if (ui.teaser.style.order !== o) ui.teaser.style.order = o;
    }
    placeTeaser();
    /* 26/10 (Max : « sur les écrans normaux, si ça ne rentre pas, on ne met pas le premier ») : à l'ordinateur, l'annonce
       qui finirait sous le bas de la fenêtre (page en haut) ne se montre pas. Mesurée toujours affichée, dans le même
       calcul : la décision ne dépend pas de son propre retrait, rien ne clignote. */
    function fitTeaser() {
      var t = ui.teaser;
      t.classList.remove('is-out');
      if (t.hidden || !wideMq.matches || !s1) return;
      /* Le premier écran est centré dans sa colonne : sa place dans la page (page en haut) ; collant, sa place dans la fenêtre */
      var st = s1.querySelector('.bisou-s1-sticky');
      var stuck = st && window.getComputedStyle(st).position === 'sticky';
      var bottom = t.getBoundingClientRect().bottom + (stuck ? 0 : (window.pageYOffset || 0));
      if (bottom > window.innerHeight - 12) t.classList.add('is-out');
    }
    /* Le haut du bloc juste sous l'en-tête (son bas, pas sa hauteur : le bandeau du haut le suit) ; la marge haute du bloc
       (44 px) laisse l'air au-dessus du titre, même si l'en-tête bouge encore un peu pendant la mesure */
    function boxY() {
      var hd = document.querySelector('.section-header') || document.querySelector('sticky-header');
      var hb = hd ? Math.max(0, Math.round(hd.getBoundingClientRect().bottom)) : 0;
      return Math.max(0, Math.round(ui.box.getBoundingClientRect().top + (window.pageYOffset || 0) - hb + 4));
    }
    function goTo(y) { try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (x) { window.scrollTo(0, y); } }
    ui.teaser.addEventListener('click', function (e) {
      e.preventDefault();
      goTo(boxY());
      /* La page se resserre pendant la descente (67 px à 1 440 × 900, mesuré le 22/10) : on remesure à l'arrivée et on
         ajuste, à la fin du défilement et au plus tard après une seconde */
      var n = 0;
      function fix() {
        if (++n > 2) return;
        var y = boxY();
        if (Math.abs(y - (window.pageYOffset || 0)) > 8) goTo(y);
      }
      window.addEventListener('scrollend', fix);
      setTimeout(fix, 1000);
      /* Plus d'écoute ensuite : un défilement du visiteur ne le ramène jamais au bloc */
      setTimeout(function () { window.removeEventListener('scrollend', fix); }, 2500);
    });
    root.classList.add(CFG.hideOld ? 'bvf-duo-on' : 'bvf-duo-off');
    /* Sa place est gardée dès maintenant : rien ne saute quand le compagnon arrive */
    ui.box.hidden = false;
    ui.box.classList.add('is-loading');
    layout();
    pullTrust();
    if (window.ResizeObserver && s1) {
      var ro = new ResizeObserver(function () { pullTrust(); });
      ro.observe(s1);
      if (s1.querySelector('.bisou-s1-sticky')) ro.observe(s1.querySelector('.bisou-s1-sticky'));
    }
    /* « En savoir plus » s'ouvre ou se ferme : la classe change, pas toujours la taille. On recalcule tout
       de suite, puis à la fin des transitions du module (fermeture en .42 s, grille en .6 s). */
    if (window.MutationObserver && s1) {
      var pullT = [];
      var mo = new MutationObserver(function (list) {
        if (!rootClassMoved(list)) return;
        pullTrust();
        pullT.forEach(clearTimeout);
        pullT = [setTimeout(pullTrust, 450), setTimeout(pullTrust, 800)];
      });
      mo.observe(s1, { attributes: true, attributeFilter: ['class'] });
      mo.observe(root, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }
    var hostInfo = document.querySelector('.product__info-container');
    if (hostInfo && window.MutationObserver) {
      var mvT = null;
      new MutationObserver(function () {
        clearTimeout(mvT);
        mvT = setTimeout(function () {
          var t = trustAnchor();
          if (t && ui.box.previousElementSibling !== t) t.parentNode.insertBefore(ui.box, t.nextSibling);
          placeTeaser();
          pullTrust();
          fitTeaser();
        }, 150);
      }).observe(hostInfo, { childList: true, subtree: true });
    }

    /* pack : les compagnons du pack, en rangs dans cands (un ou deux : un pack de deux ou de trois tirages) */
    var state = { main: null, mv: null, cands: [], pack: [], busy: false };
    var token = 0;
    /* Les compagnons qu'on a quittés par « Proposer un autre » (des handles), pour la flèche retour */
    var hist = [], flashT = null;

    /* Sens d'un tirage : ses balises d'abord, sinon la zone mesurée sur le visuel ; rien de sûr = '' */
    function orient(it) {
      var tg = tagOrient(it && it.product);
      if (tg) return tg;
      var d = it && it.wallImg, r = d && d.known && d.ratio;
      return r ? (r < 0.98 ? 'v' : (r > 1.02 ? 'h' : 'c')) : '';
    }

    /* L'image d'un tirage, mesurée et recadrée une seule fois, à la demande.
       27/10 : sa hauteur suit la densité de l'écran. Le mur montre ses tirages à 360 px de haut au plus
       (--bvf-wall-h de .is-tall, bisou-duo.css) : 400 suffisent sur un écran de densité 1, 640 restent
       au-delà de 1,6 (téléphone, iPad, Retina). */
    var WALL_PX = Math.min(640, Math.ceil(360 * Math.max(1, window.devicePixelRatio || 1) / 80) * 80);
    /* 01/11 : au téléphone (moins de 750 px), deux tirages horizontaux se partagent la largeur du mur : leur
       cadre fait environ 110 px de haut à 375, et 640 px d'image en servaient trois fois trop. La hauteur suit
       alors la demi-largeur de l'écran (210 px au plus, --bvf-wall-h du téléphone) ; le vertical et
       l'ordinateur ne changent pas. */
    function wallPx(ratio) {
      if (!(ratio > 1.02) || !window.matchMedia('(max-width: 749px)').matches) return WALL_PX;
      var h = Math.min(210, (window.innerWidth - 60) / 2 / ratio);
      return Math.min(WALL_PX, Math.ceil(h * Math.max(1, window.devicePixelRatio || 1) / 80) * 80);
    }
    function prep(it) {
      if (!it.prepP) {
        var info = imgInfo(it.product, it.variant);
        it.prepP = measure(info.src).then(function (b) {
          var d = cropped(info, b, WALL_PX), px = d.known ? wallPx(d.ratio) : WALL_PX;
          it.wallImg = px < WALL_PX ? cropped(info, b, px) : d;
        });
      }
      return it.prepP;
    }

    /* Les compagnons possibles pour le format et la finition choisis, classés (20/10) */
    function refresh() {
      var my = ++token;
      var vid = currentVariantId();
      Promise.all([getProduct(CFG.handle), cartP || readCart()]).then(function (got) {
        var main = got[0];
        var list = companionHandles(got[1]);
        var mv = (main.variants || []).filter(function (v) { return v.id === vid; })[0] || main.variants[0];
        return Promise.all(list.map(function (c) {
          return getProduct(c.h).then(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available && sameOptions(x, mv); })[0];
            return { handle: c.h, product: p, variant: v || null };
          }).catch(function () { return null; });
        })).then(function (res) {
          if (my !== token) return;
          var known = res.filter(Boolean);
          var mainIt = { handle: CFG.handle, product: main, variant: mv, main: true };
          var cands = known.filter(function (c) { return c.variant; });
          /* Le sens vient des balises : seul un tirage sans balise d'orientation attend la mesure de son image */
          var unsure = [mainIt].concat(cands).filter(function (it) { return !tagOrient(it.product); });
          return Promise.all(unsure.map(prep)).then(function () {
            if (my !== token) return;
            /* Même sens que le vôtre, sans exception (16/10) : rien de valable, le bloc reste caché */
            var o = orient(mainIt);
            cands = cands.filter(function (c) { return sameSense(o, orient(c)); });
            var wish = wishHandles(), recent = recentHandles(), byH = {};
            cands.forEach(function (c) { byH[c.handle] = c; });
            /* Le pack à garder : celui de la page, sinon celui retenu pour la visite */
            var want = state.pack.length
              ? state.pack.map(function (i) { return state.cands[i] && state.cands[i].handle; }).filter(Boolean)
              : packMemo();
            var ranked = classer(main, cands.map(function (c) { return c.product; }), {
              wish: wish,
              recent: recent,
              team: teamHandles(),
              gouts: known.filter(function (c) { return wish.indexOf(c.handle) > -1; })
                .map(function (c) { return c.product; })
            });
            /* Un compagnon gardé passé au-delà des SHOW premiers y revient, à la place du dernier */
            var top = ranked.slice(0, SHOW);
            ranked.slice(SHOW).forEach(function (r) { if (want.indexOf(r.handle) > -1) top.push(r); });
            for (var k = top.length - 1; top.length > SHOW && k >= 0; k--) if (want.indexOf(top[k].handle) < 0) top.splice(k, 1);
            cands = top.map(function (r) {
              var c = byH[r.handle];
              c.raison = r.raison;
              /* La raison dans la langue de la page (pont Liquid, why_<raison>) ; RAISONS garde le français */
              c.texte = L['why_' + r.raison] || r.texte;
              return c;
            });
            /* Le pack garde ses compagnons encore valables (format changé, panier relu) ; sinon le premier du classement */
            var hs = cands.map(function (c) { return c.handle; });
            var pack = want.map(function (h) { return hs.indexOf(h); })
              .filter(function (i) { return i > -1; });
            if (!pack.length && cands.length) pack = [0];
            /* Seules les images montrées sont attendues ; les suivantes se préparent ensuite */
            return Promise.all([prep(mainIt)].concat(pack.map(function (i) { return prep(cands[i]); }))).then(function () {
              if (my !== token) return;
              state.main = mainIt;
              state.mv = mv;
              state.cands = cands;
              state.pack = pack;
              render(true);
              /* Les suivants se préparent une fois les deux images montrées arrivées : rien ne leur prend le réseau */
              var ims = ui.wall.querySelectorAll('img'), left = ims.length;
              function more() { if (--left <= 0) cands.forEach(prep); }
              ims.forEach(function (im) {
                if (im.complete) more();
                else { im.addEventListener('load', more); im.addEventListener('error', more); }
              });
              setTimeout(function () { cands.forEach(prep); }, 4000);
            });
          });
        });
      }).catch(function () { ui.box.hidden = true; ui.teaser.hidden = true; });
    }

    function img(it) {
      var data = it.wallImg;
      var im = el('img');
      im.alt = '';
      im.decoding = 'async';
      im.setAttribute('data-r', String((data && data.ratio) || 0.8));
      im.addEventListener('load', function () { im.classList.add('is-in'); });
      im.addEventListener('error', function () {
        if (im.getAttribute('data-fb') || !data || !data.plain) return;
        im.setAttribute('data-fb', '1');
        im.src = sized(data.plain, 600);
      });
      if (data) im.src = data.url;
      return im;
    }

    /* Le mur : les tirages du pack (et la place du troisième) à la même hauteur, sans dépasser la largeur */
    function layout() {
      ui.stage.classList.toggle('is-wide', ui.stage.clientWidth >= 520 && !window.matchMedia('(max-width: 749px)').matches);
      setTall();
      var frames = ui.wall.querySelectorAll('.bvf-assoc__frame');
      /* Les marges de côté posées pour la seconde rangée (plus bas) se retirent avant de mesurer */
      ui.wall.style.paddingLeft = ui.wall.style.paddingRight = '';
      var cs = window.getComputedStyle(ui.wall);
      var W = ui.wall.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var H = parseFloat(cs.getPropertyValue('--bvf-wall-h')) || 260;
      if (W <= 0) return;
      /* Écran bas : les cadres ne dépassent pas la place que laisse le mur (voir stageRoom) */
      var room = stageRoom();
      if (room) H = Math.min(H, Math.max(LOW_MIN, room - LOW_PAD));
      var gap = Math.max(16, Math.min(40, W * 0.07));
      /* Pendant le calcul : la hauteur que prendront les deux tirages du pack, du sens du vôtre (même formule qu'en dessous) */
      if (!frames.length) {
        var load = Math.floor(Math.min(H, (W - gap) / (2 * (RATIO[MAIN_O] || RATIO.v))));
        ui.wall.style.setProperty('--bvf-wall-load', load + 'px');
        fitStage(load);
        alignTail();
        return;
      }
      /* 23/10 : à partir de 4 tirages, deux rangées (3 + 2 ou 2 + 2) ; sur une seule, cinq cadres devenaient
         des timbres. La première rangée donne la taille ; ROWGAP garde la place des légendes de la première. */
      var rows = frames.length >= 4 ? 2 : 1, per = Math.ceil(frames.length / rows), ROWGAP = 66;
      ui.wall.classList.toggle('is-rows', rows > 1);
      var sum = 0;
      for (var q = 0; q < per; q++) sum += Number(frames[q].getAttribute('data-r')) || 0.8;
      var hh = Math.min(rows > 1 ? (H - ROWGAP) / 2 : H, (W - gap * (per - 1)) / sum);
      ui.wall.style.setProperty('--bvf-gap', gap + 'px');
      var minW = Infinity;
      frames.forEach(function (f) {
        var r = Number(f.getAttribute('data-r')) || 0.8;
        var im = f.querySelector('img');
        var w = Math.floor(hh * r);
        f.style.width = w + 'px';
        minW = Math.min(minW, w);
        if (!im) return;
        im.style.height = Math.floor(hh) + 'px';
        im.style.width = w + 'px';
      });
      /* Deux rangées : le mur se resserre à la largeur de la première, la suivante passe dessous */
      if (rows > 1) {
        var rowW = gap * (per - 1) + 1;
        for (var q2 = 0; q2 < per; q2++) rowW += parseFloat(frames[q2].style.width) || 0;
        var side = Math.max(parseFloat(cs.paddingLeft), (ui.wall.clientWidth - rowW) / 2);
        ui.wall.style.paddingLeft = ui.wall.style.paddingRight = Math.floor(side) + 'px';
      }
      /* Des cadres étroits (téléphone, pack de trois) : « Changer » se fait icône */
      ui.wall.classList.toggle('is-tight', ui.wall.classList.contains('is-3') && minW < 118);
      /* Le mur garde la hauteur du pack de deux quand on passe à trois (22/10, v7-9 : rien ne saute au clic ;
         avant, il perdait 120 px à 1 920 × 1 080 et le prix et le bouton remontaient d'autant) */
      var sum2 = 0;
      for (var i = 0; i < Math.min(2, frames.length); i++) sum2 += Number(frames[i].getAttribute('data-r')) || 0.8;
      var hh2 = Math.floor(Math.max(hh, Math.min(H, (W - gap) / sum2)));
      fitStage(hh2);
      /* Le mur du pack de trois garde la hauteur de celui de deux ; 29/10 (c29w-associez-le-mieux) : à l'ordinateur aussi,
         le mur n'y prenant plus la hauteur de la galerie (bisou-duo.css) */
      ui.wall.style.minHeight = frames.length > 2 ?
        (hh2 + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom)) + 'px' : '';
      /* La raison d'un compagnon se montre si sa légende, « Changer » compris, reste dans le mur (2 px de marge) */
      ui.wall.querySelectorAll('.bvf-assoc__cap').forEach(function (c) {
        c.classList.remove('is-nowhy');
        if (c.querySelector('.bvf-assoc__why') && c.parentNode.offsetTop + c.offsetTop + c.offsetHeight > ui.wall.clientHeight - 2) c.classList.add('is-nowhy');
      });
      alignTail();
    }

    /* À l'ordinateur, la galerie à côté (20/10 au soir, Max : « beaucoup plus grand », « aligné avec le
       tirage ») : le mur prend la hauteur de l'image de la galerie, et le bloc garde sous lui la place qu'il
       faut pour qu'en bas de la colonne, là où la galerie cesse de suivre la page, le milieu du mur tombe
       sur le milieu du tirage. Ailleurs (tablette, téléphone), rien ne change. */
    function galleryImg() {
      return document.querySelector('media-gallery .product__media-item.is-active .product__media img') ||
        document.querySelector('media-gallery .product__media-item .product__media img');
    }
    /* La colonne de la galerie suit la page : c'est le plus extérieur des éléments « sticky » (la galerie en
       contient un autre, qui ne bouge que de quelques pixels dans son cadre) */
    function stickyOf(e) {
      var s = null;
      for (var p = e && e.parentElement; p && p !== document.body; p = p.parentElement) {
        if (window.getComputedStyle(p).position === 'sticky') s = p;
      }
      return s;
    }
    /* La hauteur du mur : celle de l'image de la galerie, sans dépasser les tirages du mur + 120 px de mur
       au-dessus et en dessous (un tirage vertical ferait sinon un mur de 730 px à moitié vide) */
    var galH;   /* posée par setTall(), appelée par layout() dès le début */
    function fitStage(frameH) {
      if (!(galH && ui.stage.classList.contains('is-tall'))) { ui.stage.classList.remove('is-low'); return; }
      var want = Math.round(Math.min(galH, frameH + 240)), room = stageRoom();
      var low = room > 0 && want > room;
      ui.stage.classList.toggle('is-low', low);
      ui.stage.style.setProperty('--bvf-stage-h', (low ? Math.max(room, Math.round(frameH) + LOW_PAD) : want) + 'px');
    }
    /* 28/10 au soir (c28b-associez-le-petits-ecrans, Max : « sur petits écrans […] la cellule qui enferme les deux
       cadres […] est trop haute […] on ne voit pas les informations du associez-le […] ça rentre tout pile, mais
       personne ne le fait ») : à l'ordinateur, le bloc entier (titre, prix, paliers, mur, boutons) tient dans l'écran
       avec LOW_AIR px de jeu (l'en-tête qui revient en fait 101). Sinon le mur se resserre (marges du mur plus courtes,
       .is-low dans bisou-duo.css), puis les cadres. À 1 920 × 950, le bloc tient déjà : rien ne change.
       Rend la hauteur que peut prendre le mur (--bvf-stage-h), en pixels CSS du bloc ; 0 hors de l'ordinateur. */
    var LOW_AIR = 140, LOW_PAD = 88, LOW_MIN = 150;
    function stageRoom() {
      if (!galH || !ui.stage.classList.contains('is-tall') || ui.box.hidden) return 0;
      var hd = ui.box.querySelector('.bvf-assoc__head');
      if (!hd) return 0;
      var zm = ui.box.offsetWidth ? ui.box.getBoundingClientRect().width / ui.box.offsetWidth : 1;
      /* Ce qui n'est pas le mur : du titre au bas du bloc (prix, paliers, boutons), la marge sous le mur comprise */
      var rest = (ui.box.getBoundingClientRect().bottom - hd.getBoundingClientRect().top - ui.stage.getBoundingClientRect().height) / (zm || 1);
      rest += parseFloat(window.getComputedStyle(ui.stage).paddingBottom) || 0;
      return Math.max(1, Math.floor(window.innerHeight / (zm || 1) - LOW_AIR - rest));
    }
    function setTall() {
      var img = galleryImg(), st = img && stickyOf(img);
      var on = !!(st && window.matchMedia('(min-width: 990px)').matches && img.getBoundingClientRect().right <= ui.box.getBoundingClientRect().left);
      ui.stage.classList.toggle('is-tall', on);
      galH = on ? img.getBoundingClientRect().height : 0;
      if (on) ui.stage.style.setProperty('--bvf-stage-h', Math.round(galH) + 'px');
      else {
        ui.stage.style.removeProperty('--bvf-stage-h');
        ui.box.style.removeProperty('--bvf-assoc-tail');
      }
    }
    function alignTail() {
      var img = galleryImg(), st = ui.stage.classList.contains('is-tall') && img && stickyOf(img);
      if (!st || ui.box.hidden) return;
      /* Fin de course de la galerie : le bas de l'élément qui suit la page se pose sur le bas de son parent */
      var par = st.parentElement, pcs = window.getComputedStyle(par);
      var end = par.getBoundingClientRect().bottom - (parseFloat(pcs.paddingBottom) || 0) - (parseFloat(pcs.borderBottomWidth) || 0) -
        (parseFloat(window.getComputedStyle(st).marginBottom) || 0);
      var ir = img.getBoundingClientRect();
      var printMid = end - (st.getBoundingClientRect().bottom - (ir.top + ir.height / 2));
      /* 28/10 (c28-fiche-associez-le, Max : « il faut vraiment que ça soit centré sur notre tirage. Il se décale un peu ») :
         le centre visé est celui de « votre tirage » sur le mur, pas celui du mur (les noms dessous et le bouton du bas
         le décalaient de 53 px vers le bas à 1 920) */
      var mine = ui.wall.querySelector('.bvf-assoc__frame.is-main');
      var sr = (mine && mine.offsetHeight ? mine : ui.stage).getBoundingClientRect();
      var tail = parseFloat(window.getComputedStyle(ui.box).marginBottom) || 0;
      /* La fiche est zoomée à l'ordinateur (zoom CSS) : l'écart mesuré à l'écran se ramène en pixels CSS de la marge */
      var zm = ui.box.offsetWidth ? ui.box.getBoundingClientRect().width / ui.box.offsetWidth : 1;
      var next = Math.max(24, Math.round(tail + ((sr.top + sr.height / 2) - printMid) / (zm || 1)));
      /* Garde-fou : au-delà d'un écran de vide, la mesure est fausse (galerie montée autrement) : marge d'origine */
      if (next > window.innerHeight * 0.6) { ui.box.style.removeProperty('--bvf-assoc-tail'); return; }
      if (Math.abs(next - tail) > 1) ui.box.style.setProperty('--bvf-assoc-tail', next + 'px');
    }
    /* 28/10 (c28-fiche-associez-le, Max : « en savoir plus […] 75-25 et en dessous […] 60-40 ») : la rangée des boutons
       reprend les colonnes et la hauteur de la rangée du haut (« Ajouter au panier » / « En savoir plus »), mesurées */
    function syncRow() {
      var cell = document.querySelector('.bisou-buy-row .bisou-info-cell');
      var atc = document.querySelector('.bisou-buy-row .product-form__submit');
      /* offsetWidth : la fiche est zoomée à l'ordinateur (zoom CSS), la mesure doit rester en pixels CSS */
      var w = cell ? cell.offsetWidth : 0, h = atc ? atc.offsetHeight : 0;
      if (w > 60) ui.box.style.setProperty('--bvf-col2', Math.round(w) + 'px'); else ui.box.style.removeProperty('--bvf-col2');
      if (h > 30) ui.box.style.setProperty('--bvf-btn-h', Math.round(h) + 'px'); else ui.box.style.removeProperty('--bvf-btn-h');
    }
    syncRow();
    if (window.ResizeObserver) {
      var rowRo = new ResizeObserver(syncRow);
      var topRow = document.querySelector('.bisou-buy-row');
      if (topRow) rowRo.observe(topRow);
    }
    if (window.ResizeObserver) {
      /* 28/10 (c28-fiche-associez-le) : l'image de la galerie grandit quand on défile (l'en-tête se retire) ; mesuré au
         milieu de son changement, le calage tombait 44 px trop bas à 1 920. Un second passage, une fois la galerie posée,
         hors de l'écran (le bloc est encore loin sous la fenêtre quand ça arrive) */
      var galT = null;
      var galRo = new ResizeObserver(function () {
        if (!isOff()) layout();
        clearTimeout(galT);
        galT = setTimeout(function () { if (!isOff()) layout(); }, 450);
      });
      var gal = document.querySelector('media-gallery');
      if (gal) galRo.observe(gal);
    }
    window.addEventListener('load', function () { if (!isOff()) layout(); });
    var rz = null;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { placeTeaser(); layout(); fitTeaser(); }, 100); });
    if (window.MutationObserver) {
      new MutationObserver(function (list) { if (rootClassMoved(list) && !isOff()) layout(); }).observe(root, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }

    function frame(it, cls) {
      var f = el('figure', 'bvf-assoc__frame' + (cls ? ' ' + cls : ''));
      f.setAttribute('data-h', it.handle);
      f.setAttribute('data-r', String((it.wallImg && it.wallImg.ratio) || 0.8));
      /* Sous chaque tirage, à la même hauteur : « Votre tirage » ; sous un compagnon, pourquoi lui, « Changer »
         et, dans un pack de trois, « Retirer » */
      /* 30/10 (c30b-associez-le-retouches, Max : « on enlève le texte de votre tirage, laisse juste en dessous Gobi ») :
         plus de légende sous votre tirage */
      if (it.main) {
        f.appendChild(img(it));
        /* 03/11 (Max, PDF de la copie d'essai : « on peut laisser le truc votre tirage à côté ») : la légende revient */
        f.appendChild(el('figcaption', null, L.yours || 'Votre tirage'));
        return f;
      }
      var name = it.product.title + (ARTISTS[it.handle] ? ' — ' + ARTISTS[it.handle] : '') + ' · ' + money(it.variant.price);
      var a = el('a', 'bvf-assoc__link');
      a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + it.handle + '?variant=' + it.variant.id;
      a.title = name;
      a.setAttribute('aria-label', name);
      a.appendChild(img(it));
      f.appendChild(a);
      var cap = el('figcaption', 'bvf-assoc__cap');
      /* 26/10 : au survol, le titre du tirage proposé (sous le vôtre, « Votre tirage ») */
      /* 27/10 (Max : « pas une bulle […] le texte dessous qui reste ») : le titre et l'artiste, affichés en permanence */
      var nm = el('span', 'bvf-assoc__nm', it.product.title);
      if (ARTISTS[it.handle]) nm.appendChild(el('span', 'bvf-assoc__by', ARTISTS[it.handle]));
      cap.appendChild(nm);
      /* 30/10 (c30b) : son prix barré et son prix dans le lot, remplis par render() */
      cap.appendChild(el('span', 'bvf-assoc__cp'));
      if (it.texte) {
        var why = el('span', 'bvf-assoc__why');
        if (it.raison === 'wish') why.innerHTML = HEART;
        why.appendChild(document.createTextNode(it.texte));
        cap.appendChild(why);
      }
      var tools = el('span', 'bvf-assoc__tools');
      var sw = el('button', 'bvf-assoc__swap');
      sw.type = 'button';
      /* 23/10 (Max, téléphone : « le bouton changer, peut-être un autre serait mieux ») : « Remplacer » ouvre le
         sélecteur au lieu de tirer la suggestion suivante à l'aveugle */
      sw.innerHTML = SWAP + '<span>' + (L.replace || 'Remplacer') + '</span>';
      /* 28/10 (langues) : en japonais, le titre puis le verbe (「…」を入れ替える), comme 「…」を外す du tiroir */
      var JA = /^ja/.test(document.documentElement.lang || '');
      sw.setAttribute('aria-label', JA ? '「' + it.product.title + '」を' + (L.replace || '入れ替える') : (L.replace || 'Remplacer') + (L.colon || ' : ') + it.product.title);
      sw.setAttribute('aria-haspopup', 'dialog');
      sw.addEventListener('click', function () { openPicker(it.handle, sw); });
      tools.appendChild(sw);
      var rm = el('button', 'bvf-assoc__rm');
      rm.type = 'button';
      rm.innerHTML = CLOSE;
      rm.setAttribute('aria-label', JA ? '「' + it.product.title + '」を' + (L.remove || 'セットから外す') : (L.remove || 'Retirer du pack') + (L.colon || ' : ') + it.product.title);
      rm.addEventListener('click', function () { removeH(it.handle); });
      tools.appendChild(rm);
      cap.appendChild(tools);
      f.appendChild(cap);
      return f;
    }
    /* Le prochain rang du classement qui n'est pas déjà dans le pack, après from (−1 : le meilleur) ; −1 s'il n'y en a pas */
    function freeIdx(from) {
      var t = state.cands.length;
      for (var k = 1; k <= t; k++) {
        var i = (from + k + t) % t;
        if (state.pack.indexOf(i) < 0) return i;
      }
      return -1;
    }
    function slotOf(h) {
      for (var s = 0; s < state.pack.length; s++) if (state.cands[state.pack[s]] && state.cands[state.pack[s]].handle === h) return s;
      return -1;
    }
    function focusIn(sel) {
      var n = ui.wall.querySelector(sel);
      if (n && typeof n.focus === 'function') { try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); } }
    }
    /* Changer un compagnon : la suggestion suivante du classement (même sens, hors panier : déjà filtrés) */
    function swap(h) {
      var s = slotOf(h);
      if (s < 0 || state.busy) return;
      var j = freeIdx(state.pack[s]);
      if (j < 0) return;
      var comp = state.cands[j], my = token;
      prep(comp).then(function () {
        if (my !== token || state.pack.indexOf(j) > -1 || state.pack[s] == null || !state.cands[state.pack[s]] || state.cands[state.pack[s]].handle !== h) return;
        state.pack[s] = j;
        render(false, comp.handle);
        focusIn('.bvf-assoc__frame[data-h="' + comp.handle + '"] .bvf-assoc__swap');
      });
    }
    /* Un lot de n tirages (2 à 5, 23/10) : on complète avec les meilleures suggestions qui n'y sont pas encore,
       ou on retire les derniers venus */
    function setSize(n) {
      if (state.busy) return;
      n = Math.max(2, Math.min(MAXN, n));
      if (state.pack.length + 1 < n) {
        var add = [], seen = state.pack.slice();
        while (seen.length + add.length + 1 < n) {
          var j = -1;
          for (var i = 0; i < state.cands.length; i++) if (seen.indexOf(i) < 0 && add.indexOf(i) < 0) { j = i; break; }
          if (j < 0) break;
          add.push(j);
        }
        if (!add.length) return;
        var my = token;
        Promise.all(add.map(function (i) { return prep(state.cands[i]); })).then(function () {
          if (my !== token) return;
          add.forEach(function (i) { if (state.pack.indexOf(i) < 0 && state.pack.length + 1 < MAXN) state.pack.push(i); });
          render(false, state.cands[add[add.length - 1]].handle);
        });
      } else if (state.pack.length + 1 > n) {
        state.pack = state.pack.slice(0, n - 1);
        render(false);
      }
    }
    /* Mettre un tirage choisi dans le lot : à la place de « h », ou en plus */
    function choose(i, h) {
      if (state.busy || i < 0 || !state.cands[i] || state.pack.indexOf(i) > -1) return;
      var s = h ? slotOf(h) : -1;
      if (!h && state.pack.length + 1 >= MAXN) return;
      var comp = state.cands[i], my = token;
      prep(comp).then(function () {
        if (my !== token || state.pack.indexOf(i) > -1) return;
        if (s > -1 && state.cands[state.pack[s]] && state.cands[state.pack[s]].handle === h) state.pack[s] = i;
        else if (!h && state.pack.length + 1 < MAXN) state.pack.push(i);
        else return;
        render(false, comp.handle);
      });
    }

    /* « Proposer un autre » (26/10) : le compagnon suivant du classement (même sens, même format, même finition, hors
       panier : déjà filtrés) prend la place du dernier du lot ; la flèche remet le précédent. À chaque changement, le
       titre et l'artiste s'affichent, puis s'effacent. */
    function flashName(c) {
      if (!c || !c.product) return;
      ui.flash.textContent = c.product.title + (ARTISTS[c.handle] ? ' — ' + ARTISTS[c.handle] : '');
      ui.flash.classList.add('is-on');
      clearTimeout(flashT);
      flashT = setTimeout(function () { ui.flash.classList.remove('is-on'); }, 2600);
    }
    function putLast(i, done) {
      var s = state.pack.length - 1;
      if (state.busy || s < 0 || i < 0 || !state.cands[i] || state.pack.indexOf(i) > -1) return;
      var comp = state.cands[i], was = state.cands[state.pack[s]], my = token;
      /* 28/10 (c28-fiche-associez-le) : le geste se voit tout de suite — l'icône tourne, le tirage qui part s'estompe ;
         le suivant entre en fondu (is-enter). Rien ne change de taille : notre tirage ne bouge pas. */
      var leaving = was && ui.wall.querySelector('.bvf-assoc__frame[data-h="' + was.handle + '"]');
      ui.other.setAttribute('aria-busy', 'true');
      if (leaving) leaving.classList.add('is-leaving');
      function idle() { ui.other.removeAttribute('aria-busy'); if (leaving) leaving.classList.remove('is-leaving'); }
      prep(comp).then(function () {
        idle();
        if (my !== token || state.pack.indexOf(i) > -1 || state.cands[state.pack[s]] !== was) return;
        state.pack[s] = i;
        done(was);
        render(false, comp.handle);
        flashName(comp);
      }, idle);
    }
    ui.other.addEventListener('click', function () {
      var s = state.pack.length - 1;
      if (s < 0) return;
      putLast(freeIdx(state.pack[s]), function (was) { if (was) hist.push(was.handle); });
    });
    ui.back.addEventListener('click', function () {
      while (hist.length) {
        var h = hist[hist.length - 1], i = -1;
        state.cands.forEach(function (c, k) { if (c && c.handle === h) i = k; });
        if (i > -1 && state.pack.indexOf(i) < 0) { putLast(i, function () { hist.pop(); }); return; }
        hist.pop();
      }
      ui.back.disabled = true;
      ui.back.classList.add('is-gone');
    });

    /* ---------- Le sélecteur (23/10) ----------
       Max : « ça ouvre un ensemble stylé avec vus récemment / la wishlist et autres trucs, genre mêmes couleurs ».
       Les candidats sont ceux du classement (même format, même finition, même sens, hors panier) ; un filtre par
       origine, la raison et le prix exact de la variante qui serait ajoutée. */
    var pick = null;
    function pickerUi() {
      if (pick) return pick;
      var wrap = el('div', 'bvf-assoc-pick');
      wrap.hidden = true;
      var veil = el('div', 'bvf-assoc-pick__veil');
      var panel = el('div', 'bvf-assoc-pick__panel');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-labelledby', 'bvf-assoc-pick-t');
      panel.tabIndex = -1;
      var top = el('div', 'bvf-assoc-pick__top');
      var t = el('h3', 'bvf-assoc-pick__t');
      t.id = 'bvf-assoc-pick-t';
      var sub = el('p', 'bvf-assoc-pick__sub');
      var x = el('button', 'bvf-assoc-pick__x');
      x.type = 'button';
      x.innerHTML = CLOSE;
      x.setAttribute('aria-label', L.close || 'Fermer');
      var tt = el('div');
      tt.appendChild(t);
      tt.appendChild(sub);
      top.appendChild(tt);
      top.appendChild(x);
      var chips = el('div', 'bvf-assoc-pick__chips');
      chips.setAttribute('role', 'group');
      var grid = el('ul', 'bvf-assoc-pick__grid');
      grid.setAttribute('role', 'list');
      panel.appendChild(top);
      panel.appendChild(chips);
      panel.appendChild(grid);
      wrap.appendChild(veil);
      wrap.appendChild(panel);
      document.body.appendChild(wrap);
      veil.addEventListener('click', closePicker);
      x.addEventListener('click', closePicker);
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePicker(); });
      pick = { wrap: wrap, panel: panel, t: t, sub: sub, chips: chips, grid: grid, filtre: 'tous', h: null, from: null };
      return pick;
    }
    function inFiltre(c, f) {
      if (f === 'wish') return wishHandles().indexOf(c.handle) > -1;
      if (f === 'recent') return recentHandles().indexOf(c.handle) > -1;
      if (f === 'couleurs') return c.raison === 'couleurs' || c.raison === 'ambiance' || c.raison === 'gouts';
      return true;
    }
    function fillPicker() {
      var p = pick, free = [];
      state.cands.forEach(function (c, i) { if (state.pack.indexOf(i) < 0) free.push(i); });
      var F = [['tous', L.pickAll || 'Tout'], ['wish', L.pickWish || 'Coups de cœur'], ['recent', L.pickRecent || 'Vus récemment'], ['couleurs', L.pickColors || 'Mêmes couleurs']];
      p.chips.innerHTML = '';
      F.forEach(function (f) {
        var n = free.filter(function (i) { return inFiltre(state.cands[i], f[0]); }).length;
        if (f[0] !== 'tous' && !n) return;
        var b = el('button', 'bvf-assoc-pick__chip' + (p.filtre === f[0] ? ' is-on' : ''));
        b.type = 'button';
        b.setAttribute('aria-pressed', p.filtre === f[0] ? 'true' : 'false');
        b.appendChild(document.createTextNode(f[1]));
        b.appendChild(el('span', null, String(n)));
        b.addEventListener('click', function () { p.filtre = f[0]; fillPicker(); });
        p.chips.appendChild(b);
      });
      p.grid.innerHTML = '';
      free.filter(function (i) { return inFiltre(state.cands[i], p.filtre); }).forEach(function (i) {
        var c = state.cands[i];
        var li = el('li');
        var b = el('button', 'bvf-assoc-pick__item');
        b.type = 'button';
        var fig = el('span', 'bvf-assoc-pick__img');
        var im = el('img');
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        im.src = (c.wallImg && c.wallImg.url) || sized(imgInfo(c.product, c.variant).src, 360);
        fig.appendChild(im);
        b.appendChild(fig);
        b.appendChild(el('span', 'bvf-assoc-pick__name', c.product.title));
        if (ARTISTS[c.handle]) b.appendChild(el('span', 'bvf-assoc-pick__by', ARTISTS[c.handle]));
        var row = el('span', 'bvf-assoc-pick__row');
        if (c.texte && c.raison !== 'base') {
          var why = el('span', 'bvf-assoc-pick__why');
          if (c.raison === 'wish') why.innerHTML = HEART;
          why.appendChild(document.createTextNode(c.texte));
          row.appendChild(why);
        }
        row.appendChild(el('b', 'bvf-assoc-pick__price', money(c.variant.price)));
        b.appendChild(row);
        /* 29/10 (langues-continue-fiche-tirage-5) : en japonais, 「、」 entre le titre, l'artiste et le prix */
        var sep = L26 === L26S.ja ? '、' : ', ';
        b.setAttribute('aria-label', c.product.title + (ARTISTS[c.handle] ? sep + ARTISTS[c.handle] : '') + sep + money(c.variant.price));
        b.addEventListener('click', function () { var h = p.h; closePicker(); choose(i, h); });
        li.appendChild(b);
        p.grid.appendChild(li);
      });
      if (!p.grid.childNodes.length) p.grid.appendChild(el('li', 'bvf-assoc-pick__vide', L.pickNone || 'Aucun autre tirage dans ce format pour l’instant.'));
    }
    function openPicker(h, from) {
      if (state.busy || !state.cands.length) return;
      var p = pickerUi();
      p.h = h || null;
      p.from = from || null;
      p.filtre = 'tous';
      p.t.textContent = h ? (L.pickReplace || 'Remplacer ce tirage') : (L.pickAdd || 'Ajouter un tirage');
      var fmt = (state.mv && state.mv.title) || '';
      p.sub.textContent = (L.pickSub || 'Même format, même finition') + (fmt ? ' · ' + fmt : '');
      fillPicker();
      p.wrap.hidden = false;
      document.documentElement.classList.add('bvf-assoc-pick-on');
      requestAnimationFrame(function () { p.wrap.classList.add('is-open'); });
      try { p.panel.focus({ preventScroll: true }); } catch (e) { p.panel.focus(); }
    }
    function closePicker() {
      if (!pick || pick.wrap.hidden) return;
      pick.wrap.classList.remove('is-open');
      pick.wrap.hidden = true;
      document.documentElement.classList.remove('bvf-assoc-pick-on');
      if (pick.from && document.contains(pick.from)) { try { pick.from.focus({ preventScroll: true }); } catch (e) { /* rien */ } }
    }
    ui.plus.addEventListener('click', function () { openPicker(null, ui.plus); });
    function removeH(h) {
      var s = slotOf(h);
      if (s < 0 || state.pack.length < 2 || state.busy) return;
      state.pack.splice(s, 1);
      render(false);
      /* Le focus passe au palier « 3 tirages », qui remet un troisième */
      var t3 = ui.tiers.lastElementChild;
      if (t3) { try { t3.focus({ preventScroll: true }); } catch (e) { t3.focus(); } }
    }

    function plannerHref(comps) {
      var base = L.plannerUrl || '/pages/framed-wall-planner';
      var opts = (state.mv && state.mv.options) || [];
      var fmt = '', fin = '';
      opts.forEach(function (o) {
        var n = String(o || '').toLowerCase();
        if (!fmt) { var m = n.match(/\ba[234]\b/); if (m) fmt = m[0].toUpperCase(); }
        if (!fin) { if (/noir/.test(n)) fin = 'noir'; else if (/blanc/.test(n)) fin = 'blanc'; else if (/ch[eê]ne/.test(n)) fin = 'chene'; else if (/bouleau/.test(n)) fin = 'bouleau'; }
      });
      var q = 'ids=' + encodeURIComponent([CFG.handle].concat((comps || []).map(function (c) { return c.handle; })).join(','));
      if (fmt) q += '&fmt=' + fmt;
      if (fin) q += '&frame=' + fin;
      return base + (base.indexOf('?') === -1 ? '?' : '&') + q;
    }

    /* full : tout le mur est redessiné (format changé) ; sinon les cadres déjà là restent (pas de clignement)
       et seul celui qui arrive (entered, son handle) entre en glissant */
    function render(full, entered) {
      ui.box.classList.remove('is-loading');
      if (!state.mv || !state.cands.length || !state.pack.length) { ui.box.hidden = true; ui.teaser.hidden = true; return; }
      ui.box.hidden = false;
      var mv = state.mv;
      var comps = state.pack.map(function (i) { return state.cands[i]; });
      rememberPack(comps.filter(Boolean).map(function (c) { return c.handle; }));
      var n = comps.length + 1;
      var more = freeIdx(-1) > -1;

      var had = {};
      if (full) ui.wall.innerHTML = '';
      else ui.wall.querySelectorAll('.bvf-assoc__frame').forEach(function (f) { had[f.getAttribute('data-h')] = f; });
      var nodes = [state.main].concat(comps).map(function (it) {
        return had[it.handle] || frame(it, it.main ? 'is-main' : 'is-comp' + (it.handle === entered ? ' is-enter' : ''));
      });
      /* Plus de place en pointillés pour le troisième (22/10, v6-11) : le palier « 3 tirages » l'ajoute */
      Object.keys(had).forEach(function (k) { if (nodes.indexOf(had[k]) < 0) had[k].remove(); });
      nodes.forEach(function (f) { ui.wall.appendChild(f); });
      ui.wall.classList.toggle('is-3', n >= 3);
      /* Personne d'autre à proposer : « Changer » se retire */
      ui.wall.classList.toggle('is-solo', !more);
      layout();
      /* L'entrée se joue à l'image suivante ; filet de sécurité si l'onglet est en arrière-plan */
      function enter() { ui.wall.querySelectorAll('.is-enter').forEach(function (f) { f.classList.remove('is-enter'); }); }
      requestAnimationFrame(function () { requestAnimationFrame(enter); });
      setTimeout(enter, 120);

      /* Les paliers : celui atteint s'allume ; un clic change la taille du pack. Leur remise ne s'affiche que si elle
         existe, ou dans l'aperçu ; sans remise, « 2 tirages » et « 3 tirages » restent : c'est par là qu'on ajoute le troisième. */
      var pct = pctFor(n);
      /* 23/10 (Max : « Associez 2 tirages, et à droite −10 % allumé et les autres −15, −20… », « pas les deux
         grosses pastilles ») : le titre dit la taille du lot ; à droite, les remises seules, en ligne : celle
         atteinte allumée, les suivantes en gris (le prochain palier, pas un bouton cassé). Un clic règle le lot. */
      /* 26/10 (« trop le bordel ») : le titre reste « Associez-le » ; le prix du pack, juste dessous, dit combien */
      ui.title.textContent = L.title || 'Associez-le';
      ui.tiers.innerHTML = '';
      var ks = tierList(), on = 0;
      ks.forEach(function (k) { if (k <= n) on = k; });
      ks.forEach(function (k) {
        var b = el('button', 'bvf-assoc__tier' + (k === on ? ' is-on' : '') + (k < on ? ' is-past' : ''));
        b.type = 'button';
        b.setAttribute('aria-pressed', k === on ? 'true' : 'false');
        b.setAttribute('aria-label', tpl(L.tierN || '[n] tirages', k) + (L.colon || ' : ') + '−' + pctFor(k) + (L.pct || ' %'));
        b.title = tpl(L.tierN || '[n] tirages', k);
        b.appendChild(el('b', 'bvf-assoc__tierp', '−' + pctFor(k) + (L.pct || ' %')));
        b.addEventListener('click', function () { setSize(k); });
        ui.tiers.appendChild(b);
      });
      ui.tiers.hidden = !ks.length;
      ui.cumul.innerHTML = '';
      if (ks.length > 1) ks.forEach(function (k, j) {
        if (j) ui.cumul.appendChild(el('span', 'bvf-assoc__cumsep', '·'));
        var c = el(k === on ? 'b' : 'span', 'bvf-assoc__cum' + (k === on ? ' is-on' : ''), ((j ? L26.cumulN : L26.cumul) || '−[p] % [n]').replace('[p]', pctFor(k)).replace('[n]', k));
        ui.cumul.appendChild(c);
      });
      ui.cumul.hidden = !ui.cumul.childNodes.length;
      var kn = 0;
      ks.forEach(function (k) { if (!kn && k > n && pctFor(k)) kn = k; });
      ui.next.textContent = kn ? (L26.cumul || '−[p] % [n]').replace('[p]', pctFor(kn)).replace('[n]', kn) : '';
      ui.next.hidden = !kn;
      /* « Ajouter un tirage » tant que le lot a moins de 5 tirages et qu'il reste quelqu'un à proposer */
      ui.plus.hidden = n >= MAXN || !more;

      /* Le prix du pack, avant et après la remise du palier atteint */
      var sum = mv.price;
      comps.forEach(function (c) { sum += c.variant.price; });
      var after = pct ? Math.round(sum * (100 - pct) / 100) : sum;
      ui.total.innerHTML = '';
      ui.total.appendChild(el('span', 'bvf-assoc__totall', tpl(pct ? (L.packN || 'Pack de [n]') : (L.tierN || '[n] tirages'), n)));
      if (pct) {
        ui.total.appendChild(el('s', null, money(sum)));
        /* 26/10 (Max : « le −10 % en vert à droite du prix barré ») */
        ui.total.appendChild(el('span', 'bvf-assoc__pct', '−' + pct + (L.pct || ' %')));
      }
      ui.total.appendChild(el('b', null, money(after)));
      /* L'économie et le petit « aperçu » vont ensemble : au téléphone, « aperçu » ne passe plus seul à la ligne (23/10) */
      var tail = el('span', 'bvf-assoc__tail');
      if (pct) tail.appendChild(el('span', 'bvf-assoc__save', '−' + money(sum - after)));
      if (pct && PREVIEW_NOTE) {
        var pv = el('span', 'bvf-assoc__apercu', L.previewTag || 'aperçu');
        pv.title = PREVIEW_NOTE;
        tail.appendChild(pv);
      }
      if (tail.childNodes.length) ui.total.appendChild(tail);
      var PC = /^(fr|es)/.test(document.documentElement.lang || 'fr') ? ' %' : '%';
      /* 30/10 (rA34) : le « · » est peint devant chaque morceau (bisou-duo.css, .bvf-assoc__line-in) et celui qui ouvre
         une ligne est rogné ; avant, en français de 320 à 390 px, la 1re ligne finissait sur « −10 % · ». Entre deux
         morceaux, une espace sans chasse (U+200B) laisse passer à la ligne. */
      var lt = el('span', 'bvf-assoc__line-t');
      var li = el('span', 'bvf-assoc__line-in');
      lt.appendChild(li);
      li.appendChild(el('span', null, (L26.lineN || '[n]').replace('[n]', n)));
      if (pct) { li.appendChild(document.createTextNode('​')); li.appendChild(el('b', 'bvf-assoc__line-pct', '−' + pct + PC)); }
      if (kn) { li.appendChild(document.createTextNode('​')); li.appendChild(el('b', null, (L26.more || '+[k] −[p]%').replace('[k]', kn - n).replace('[p]', pctFor(kn)))); }
      ui.line.innerHTML = '';
      ui.line.appendChild(lt);
      ui.line.appendChild(el('b', 'bvf-assoc__line-p', money(after)));
      /* 30/10 (c30b-associez-le-retouches, Max : « barrer le tirage de droite, là où il y a Gobi, on met un prix qu'on barre
         et on enlève la différence ») : la remise du lot (celle de Shopify, « Lot de tirages », sur tous les tirages du
         panier) passe tout entière sur le compagnon — deux tirages à 50 € : « 50 € » barré, « 40 € ». Dans un lot de trois
         ou plus, elle se partage entre les compagnons, au prorata de leur prix ; le total payé reste celui du panier. */
      var off = sum - after, cs = 0;
      comps.forEach(function (c) { cs += c.variant.price; });
      var left = off;
      comps.forEach(function (c, j) {
        var part = j === comps.length - 1 ? left : (cs ? Math.round(off * c.variant.price / cs) : 0);
        left -= part;
        var cp = ui.wall.querySelector('.bvf-assoc__frame[data-h="' + c.handle + '"] .bvf-assoc__cp');
        if (!cp) return;
        cp.innerHTML = '';
        if (part > 0) cp.appendChild(el('s', null, money(c.variant.price)));
        cp.appendChild(el('b', null, money(c.variant.price - part)));
      });
      ui.note.textContent = pct ? NOTE : '';
      ui.note.hidden = !ui.note.textContent;

      /* L'annonce du premier écran : les tirages du pack en petit, le prix du pack */
      ui.teaser.innerHTML = '';
      var th = el('span', 'bvf-assoc-teaser__thumbs');
      /* Trois vignettes au plus : un lot de 4 ou 5 ne pousse pas l'annonce hors de sa ligne (23/10) ; le nombre est dit à côté */
      [state.main].concat(comps).slice(0, 3).forEach(function (it) {
        if (!it.wallImg || !it.wallImg.url) return;
        var ti = el('img');
        ti.alt = '';
        ti.decoding = 'async';
        ti.src = it.wallImg.url;
        th.appendChild(ti);
      });
      ui.teaser.appendChild(th);
      var tt = el('span', 'bvf-assoc-teaser__txt');
      tt.appendChild(el('b', null, L.title || 'Associez-le'));
      tt.appendChild(el('span', 'bvf-assoc-teaser__n', tpl(L.tierN || '[n] tirages', n)));
      var tp = el('span', 'bvf-assoc-teaser__price');
      if (pct) tp.appendChild(el('s', null, money(sum)));
      tp.appendChild(el('strong', null, money(after)));
      tt.appendChild(tp);
      ui.teaser.appendChild(tt);
      if (pct) ui.teaser.appendChild(el('span', 'bvf-assoc-teaser__pct', '−' + pct + (L.pct || ' %')));
      var ar = el('span', 'bvf-assoc-teaser__go');
      ar.innerHTML = NEXT;
      ui.teaser.appendChild(ar);
      /* le nom lu = le texte écrit (titre, nombre, prix barré, prix, remise) : plus d'étiquette qui en cache une partie */
      ui.teaser.removeAttribute('aria-label');
      ui.teaser.hidden = false;
      fitTeaser();

      /* Voir côte à côte : la page, avec les tirages du pack déjà posés */
      ui.compose.href = plannerHref(comps);
      ui.tryo.href = plannerHref(comps);
      ui.other.disabled = !more;
      ui.back.disabled = !hist.length;
      ui.back.classList.toggle('is-gone', !hist.length);
      ui.add.innerHTML = '';
      ui.add.appendChild(el('span', 'bvf-assoc__addlbl', tpl(L.add || 'Ajouter les [n] au panier', n)));
      ui.add.disabled = !mv.available || state.busy;
      ui.msg.hidden = true;
    }

    ui.add.addEventListener('click', function () {
      var comps = state.pack.map(function (i) { return state.cands[i]; }).filter(Boolean);
      if (state.busy || !state.mv || !comps.length) return;
      state.busy = true;
      ui.add.disabled = true;
      ui.add.setAttribute('aria-busy', 'true');
      var items = [{ id: state.mv.id, quantity: 1 }].concat(comps.map(function (c) { return { id: c.variant.id, quantity: 1 }; }));
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && typeof drawer.renderContents === 'function') {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(base + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'panier');
          if (typeof window.publish === 'function') {
            try { window.publish('cart-update', { source: 'bvf-assoc', cartData: res.j }); } catch (e) { /* bus absent */ }
          }
          if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          ui.msg.textContent = L.error || 'Un des tirages n’est plus disponible dans ce format. Essayez une autre association.';
          ui.msg.hidden = false;
        })
        .then(function () {
          state.busy = false;
          ui.add.removeAttribute('aria-busy');
          ui.add.disabled = !state.mv.available;
        });
    });

    /* Le format ou la finition change : on suit */
    var last = currentVariantId();
    function watch() {
      var v = currentVariantId();
      if (v && v !== last) { last = v; refresh(); }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-form, variant-selects, .bisou-s1-sticky')) setTimeout(watch, 60);
    });
    if (typeof window.subscribe === 'function') {
      try { window.subscribe('variant-change', function () { setTimeout(watch, 60); }); } catch (e) { /* bus absent */ }
    }
    setInterval(function () { if (!isOff()) watch(); }, 1200);
    /* Un cœur ajouté ou retiré ailleurs sur la page : la liste suit */
    document.addEventListener('bisou:wishlist', function () { setTimeout(refresh, 80); });
    /* Le panier change (ajout, retrait) : on le relit, ses tirages sortent des suggestions */
    if (typeof window.subscribe === 'function') {
      var cartT = null;
      try {
        window.subscribe('cart-update', function () {
          clearTimeout(cartT);
          cartT = setTimeout(function () { readCart(); refresh(); }, 150);
        });
      } catch (e) { /* bus absent */ }
    }

    refresh();
    /* Filet : réseau coupé ou très lent, la place gardée ne reste pas vide ; le bloc revient s'il arrive ensuite */
    setTimeout(function () { if (ui.box.classList.contains('is-loading')) { ui.box.hidden = true; ui.teaser.hidden = true; } }, 8000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
